/* Boheia interactions are lifecycle-safe in Shopify's theme editor. */
(() => {
  if (window.boheiaThemeLoaded) return;
  window.boheiaThemeLoaded = true;
  const storageKey = 'boheia-favorites-v2';
  let saved = [];
  const safeURL = value => {
    if (!value) return '';
    try { const url = new URL(value, location.origin); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const read = () => { try { const value = JSON.parse(localStorage.getItem(storageKey) || '[]'); saved = Array.isArray(value) ? value.filter(v => v && typeof v.key === 'string' && typeof v.title === 'string').slice(0, 100) : []; } catch { saved = []; } };
  read();
  function sync() {
    document.querySelectorAll('[data-saved-count]').forEach(el => { el.textContent = saved.length; });
    document.querySelectorAll('[data-card]').forEach(card => {
      const button = card.querySelector('[data-save]');
      if (!button) return;
      const active = saved.some(p => p.key === card.dataset.key);
      button.setAttribute('aria-pressed', String(active));
      button.querySelector('span').textContent = active ? '♥' : '♡';
    });
  }
  function persist() { try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch { /* Private browsing still supports this session. */ } sync(); }
  function renderSaved() {
    const dialog = document.getElementById('BoheiaSaved');
    if (!dialog) return;
    const list = dialog.querySelector('[data-saved-list]'); list.replaceChildren();
    dialog.querySelector('[data-saved-empty]').hidden = saved.length > 0;
    for (const product of saved) {
      const row = document.createElement('div'); row.className = 'b-saved-row';
      const src = safeURL(product.image);
      if (src) { const img = document.createElement('img'); img.src = src; img.alt = product.title; row.append(img); }
      const url = safeURL(product.url); const title = document.createElement(url ? 'a' : 'span');
      if (url) title.href = url; title.textContent = product.title; row.append(title);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = dialog.dataset.removeLabel; remove.dataset.removeSaved = product.key; row.append(remove); list.append(row);
    }
  }
  class BoheiaCollection extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.grid = this.querySelector('[data-grid]'); if (!this.grid) return;
      this.cards = [...this.grid.querySelectorAll('[data-card]')]; this.filter = 'all';
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-filter]'); if (!button) return;
        this.filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
        this.update();
      }, { signal: this.controller.signal });
      this.querySelector('[data-sort]')?.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      this.update(); sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      const sort = this.querySelector('[data-sort]')?.value || 'featured'; const cards = [...this.cards];
      if (sort === 'name') cards.sort((a,b) => a.dataset.name.localeCompare(b.dataset.name));
      if (sort === 'price-up') cards.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
      if (sort === 'price-down') cards.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
      let count = 0;
      for (const card of cards) { card.hidden = this.filter !== 'all' && card.dataset.category !== this.filter; if (!card.hidden) count++; this.grid.append(card); }
      const countElement = this.querySelector('[data-count]');
      countElement.textContent = [count, countElement.dataset.label].filter(v => v !== undefined && v !== '').join(' ');
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
    revealBlock(blockId) {
      const card = this.cards?.find(el => el.getAttribute('data-shopify-editor-block')?.includes(blockId));
      if (card?.hidden) this.querySelector('[data-filter="all"]')?.click();
    }
  }
  if (!customElements.get('boheia-collection')) customElements.define('boheia-collection', BoheiaCollection);
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-save]');
    if (save) {
      const card = save.closest('[data-card]'); if (!card) return;
      const key = card.dataset.key; const exists = saved.some(p => p.key === key);
      saved = exists ? saved.filter(p => p.key !== key) : [...saved, { key, title: card.dataset.name, url: card.querySelector('a.b-card-link')?.href || '', image: card.querySelector('img')?.src || '' }].slice(-100);
      persist(); return;
    }
    if (event.target.closest('[data-open-saved]')) { const d = document.getElementById('BoheiaSaved'); if (d) { renderSaved(); d.showModal(); } }
    if (event.target.closest('[data-close-saved]')) document.getElementById('BoheiaSaved')?.close();
    const remove = event.target.closest('[data-remove-saved]');
    if (remove) { saved = saved.filter(p => p.key !== remove.dataset.removeSaved); persist(); renderSaved(); document.querySelector('[data-close-saved]')?.focus(); }
    if (event.target.id === 'BoheiaSaved') { const bounds = event.target.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close(); }
  });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:block:select', event => { event.target.closest('boheia-collection')?.revealBlock(event.detail.blockId); });
  window.addEventListener('storage', event => { if (event.key === storageKey) { read(); sync(); renderSaved(); } });
  sync();
})();
